import React, { useEffect, useState } from 'react';
import { Button, Input, Space } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { LoginYn, Position } from 'components/TableSearchBox';
import { addNewSearch } from 'utils/utils';
import 'components/TableSearchBox/index.scss';

const cx = classNames.bind('./index.scss');
export interface UsereSearchBox {}

const UserSearchBox = ({}: UsereSearchBox): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchLoginYn, setSearchLoginYn] = useState<string|undefined>(undefined);
  const [searchPosition, setSearchPosition] = useState<string|undefined>(undefined);

  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setSearchLoginYn(undefined);
    setSearchPosition(undefined);
    navigate(location.pathname);
  };

  const onSearch = (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { search: value, pageNo: 1 }),
    });    
  };

  const onChangeLoginYn = (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { use: value, pageNo: 1 }),
    });      
  };

  const onChangePosition = (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { position: value, pageNo: 1 }),
    });      
  };  
  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const historySearch = getQueryString(location.search);
    if (historySearch.search) setSearchInput(historySearch.search);
    if (historySearch.use) setSearchLoginYn(historySearch.use);
    if (historySearch.position) setSearchPosition(historySearch.position);
  }, [location.search]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space>
        <LoginYn userLoginYn={searchLoginYn} onUserLoginYn={onChangeLoginYn}/>
        <Position userPosition={searchPosition} onUserPosition={onChangePosition} />
        <Input.Search
          className={cx('searchInput')}
          value={searchInput}
          placeholder="검색어를 입력해 주세요"
          onChange={onChange}
          onSearch={onSearch}
          allowClear
        />
        <Button onClick={onClickReset}>
          검색초기화
        </Button>                
      </Space>
    </div>
  );
};

export default UserSearchBox;
